var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveCollections(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67999 0.719971C0.885459 0.719971 0.23999 1.36544 0.23999 2.15997V15.9525H0.25124C0.310303 16.6908 0.927646 17.28 1.67999 17.28H12.12V16.56H1.67999C1.2778 16.56 0.95999 16.2422 0.95999 15.84C0.95999 15.4378 1.2778 15.12 1.67999 15.12H12.12V14.4H1.67999C1.28343 14.4 0.95999 14.0765 0.95999 13.68C0.95999 13.2834 1.28343 12.96 1.67999 12.96H12.12V0.719971H1.67999ZM2.75999 2.87997H9.59999C9.79827 2.87997 9.95999 3.04169 9.95999 3.23997V4.31997C9.95999 4.51825 9.79827 4.67997 9.59999 4.67997H2.75999C2.56171 4.67997 2.39999 4.51825 2.39999 4.31997V3.23997C2.39999 3.04169 2.56171 2.87997 2.75999 2.87997Z",
    fill: "#4AA23C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCollections);
export default __webpack_public_path__ + "static/media/active_collections.dee2ecb99ef968a6004f122ff980c924.svg";
export { ForwardRef as ReactComponent };